export default __webpack_public_path__ + "static/media/login-bg.938f2757.jpeg";